<template>
    <div class="campo-form">
        <div class="label-container">
            <label>{{ label }}<span style="color: #bb2a17" v-if="required">*</span></label>
            <slot name="acoes"></slot>
        </div>

        <div class="input-wrapper">
            <Dropdown
                v-model="inputValue"
                :options="processedOptions"
                optionLabel="label"
                optionValue="value"
                :name="name"
                :class="selectClasses"
                class="input"
                :placeholder="placeholder || 'Selecione'"
                @change="handleChange"
                @focus="handleFocus"
                @blur="handleBlur"
            />
            <i v-if="showIcon" class="material-symbols-outlined icone-personalizado">expand</i>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
    label: String,
    placeholder: String,
    required: Boolean,
    name: String,
    helpText: String,
    opcoesList: {
        type: Array,
        default: () => [],
    },
    modelValue: [String, Number],
    showIcon: Boolean,
});

const emit = defineEmits(['update:modelValue']);

const inputValue = ref(props.modelValue ?? '');

const processedOptions = computed(() => {
    if (!Array.isArray(props.opcoesList) || !props.opcoesList.length) return [];
    return props.opcoesList.map((option) => {
        if (typeof option === 'object' && option.value !== undefined) {
            return { value: option.value, label: option.label || String(option.value) };
        }
        return { value: option, label: String(option) };
    });
});

watch(
    () => props.modelValue,
    (newValue) => {
        inputValue.value = newValue ?? '';
    }
);

watch(
    () => props.timestampLimpeza,
    (newValue, oldValue) => {
        if (newValue !== oldValue) {
            inputValue.value = '';
        }
    }
);

watch(
    () => inputValue.value,
    (newValue) => {
        emit('update:modelValue', newValue);
    }
);
</script>

<style scoped lang="scss">
.campo-form {
    width: 100%;

    .input-wrapper {
        position: relative;
        width: 100%;
    }

    .input {
        width: 100%;
    }

    .label-container {
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 700;
        color: #252529;
    }

    .icone-personalizado {
        position: absolute;
        top: 50%;
        right: 36px; // diminua para ficar depois do ícone do Dropdown
        transform: translateY(-50%);
        cursor: grab;
        color: #adb5bd;
        z-index: 2; // garante que fique acima do input
    }
}
</style>
